import React, { createContext, useContext } from 'react';

const DetailsViewContext = createContext();

export function DetailsViewProvider({ children, value }) {
  return (
    <DetailsViewContext.Provider value={value}>
      {children}
    </DetailsViewContext.Provider>
  );
}

export function useDetailsViewContext() {
  const context = useContext(DetailsViewContext);
  if (!context) {
    throw new Error(
      'useDetailsViewContext must be used within DetailsViewProvider',
    );
  }
  return context;
}
